import { isPlatform } from "@ionic/react";
import React, { useEffect, useState } from "react";
import FriendsPage from "../src/pages/friendsPage/FriendsPage.js";
import Countdown from "./components/Shared/Countdown/Countdown.component.js";
import DailyDebtPaid from "./components/Shared/DailyDebtPaid/DailyDebtPaid.component.js";
import DayTracker from "./components/Shared/DayTracker/DayTracker.component.js";
import PaymentList from "./components/Shared/PaymentList/PaymentList.js";
import SigninResigsterModal from "./components/Shared/SigninResigsterModal/SigninResigsterModal.component.js";
import StatViewer from "./components/Shared/StatViewer/StatViewer.js";
import ActivityMonitor from "./components/Shared/Utils/activityMonitor.js";
import {
  deleteAccount,
  getPayments,
  sendPayments,
  updatePayments,
} from "./components/Shared/Utils/index.js";
import AddPayment from "./components/Shared/addPayment/AddPayment.component.js";
import BottomNav from "./components/Shared/bottomNav/BottomNav.js";
import PopupModal from "./components/Shared/popupModal/popupModal.js";
import AccountPage from "./pages/accountPage/AccountPage.js";
import OnboardingPage from "./pages/onboardingPage/OnboardingPage.js";
import "./App.css";

function App() {
  // State variables
  const [started, setStarted] = useState(false); //change bacl to false
  const [loading, setLoading] = useState(false);
  const [tempPaymentList, setTempPaymentList] = useState([]);
  const [tempSavedPaymentList, setTempSavedPaymentList] = useState([]);
  const [savedPaymentList, setSavedPaymentList] = useState(
    JSON.parse(localStorage.getItem("userPayments")) || []
  );
  const [userStats, setUserStats] = useState(
    JSON.parse(localStorage.getItem("userStats")) || []
  );
  const [accessToken, setToken] = useState(
    localStorage.getItem("accessToken") || null
  );
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData")) || []
  );
  const [userId, setUserId] = useState("");
  const [completionPercent, setCompletionPercent] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [displayError, setDisplayError] = useState("");
  const [selectedPaymentName, setSelectedPaymentName] = useState("");
  const [currentPage, setCurrentPage] = useState("home");
  const [isUserOnAndroid, setIsUserOnAndroid] = useState(false);
  const [isUserOnIos, setIsUserOnIos] = useState(false);
  const [isUserOnMobile, setIsUserOnMobile] = useState(false);

  // Constants
  useEffect(() => {
    setUserId(userData.id);
    setIsUserOnAndroid(isPlatform("android"));
    setIsUserOnIos(isPlatform("ios"));
  }, [userData]);
  useEffect(() => {
    setIsUserOnMobile(isUserOnIos || isUserOnAndroid);
  }, [isUserOnAndroid, isUserOnIos, isUserOnMobile]);

  const tempPaymentListLength = tempPaymentList.length;

  const showSavedPaymentList = savedPaymentList
    ? savedPaymentList.length > 0
    : false;

  // Effects
  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData")) || {};
    setUserData(storedUserData);
    setUserId(storedUserData.id);
  }, []);

  const [editId, setEditId] = useState(null); // Track which payment is being edited
  const [editValue, setEditValue] = useState("");
  // Handlers

  const handleUpdatePayment = (id, newPaymentName) => {
    // Update the payment's name in the temporary list
    let updatedTempList = tempPaymentList.map((payment) =>
      payment.id === id ? { ...payment, paymentName: newPaymentName } : payment
    );

    // Filter out any payments with an empty name
    updatedTempList = updatedTempList.filter(
      (payment) => payment.paymentName.trim() !== ""
    );

    // Update the state with the filtered list
    setTempPaymentList(updatedTempList);
  };

  const handleToggle = (id, listType) => {
    if (listType === "temp") {
      if (editId === id) {
        // If already in edit mode, save the edited value
        const updatedTempList = tempPaymentList.map((payment) =>
          payment.id === id ? { ...payment, paymentName: editValue } : payment
        );
        setTempPaymentList(updatedTempList);
        setEditId(null); // Exit edit mode
      } else {
        // Enter edit mode
        const currentPayment = tempPaymentList.find(
          (payment) => payment.id === id
        );
        setEditValue(currentPayment.paymentName); // Pre-fill input with current paymentName
        setEditId(id); // Set the payment to be edited
      }
    } else if (listType === "saved") {
      const paymentToUpdate = savedPaymentList.find(
        (payment) => payment._id === id
      );
      if (paymentToUpdate.complete) {
        return;
      }
      const updatedSavedList = savedPaymentList.map((payment) =>
        payment._id === id
          ? { ...payment, complete: !payment.complete }
          : payment
      );
      setTempSavedPaymentList(updatedSavedList);
      setSelectedPaymentName(paymentToUpdate.paymentName);
      setShowPopup(true);
      setPopupType("completePayment");
    }
  };

  const addPayment = (userInput) => {
    const newPayment = {
      id:
        tempPaymentListLength === 0
          ? 1
          : tempPaymentList[tempPaymentListLength - 1].id + 1,
      paymentName: userInput,
      complete: false,
    };
    setTempPaymentList([...tempPaymentList, newPayment]);
  };

  const handleStart = async () => {
    if (currentPage !== "onboarding") {
      setCurrentPage("home");
    }
    setSavedPaymentList([]);
    setDisplayError("");
    setLoading(true);
    try {
      if (userId) {
        await getPayments(
          accessToken,
          userId,
          setStarted,
          setSavedPaymentList,
          setUserStats,
          setDisplayError
        );
      }
    } catch (error) {
      console.error("Error fetching payments:", error);
      setDisplayError("Error fetching payments. Please try again later."); // Update state with error message
    } finally {
      setLoading(false);
    }
  };

  const handleSaveList = async () => {
    setDisplayError("");
    sendPayments(
      tempPaymentList,
      accessToken,
      userId,
      setStarted,
      setSavedPaymentList,
      setDisplayError
    );
  };

  const handleCompletePayment = async () => {
    setDisplayError("");
    updatePayments(tempSavedPaymentList, accessToken, userId, setDisplayError);
    localStorage.setItem("userPayments", JSON.stringify(tempSavedPaymentList));
    setSavedPaymentList(tempSavedPaymentList);
  };

  const handleSignOut = async () => {
    localStorage.clear();
    setStarted(false);
    setToken(null);
    setTempPaymentList([]);
    setSavedPaymentList([]);
    setDisplayError("");
  };

  const handleDeleteAccount = async () => {
    try {
      await deleteAccount(accessToken, userId, handleSignOut);
    } catch (error) {
      // Optionally, handle any additional errors here
      console.error("Failed to delete account:", error);
    }
  };
  // end handlers

  // tab focus after midnight
  document.addEventListener("visibilitychange", () => {
    if (!showSavedPaymentList) {
      return;
    }
    if (document.visibilityState === "visible") {
      const lastFetched = new Date(
        localStorage.getItem("fetchDateOfUserPayment")
      );
      const now = new Date();

      if (now.getDate() !== lastFetched.getDate()) {
        setStarted(false);
      }
    }
  });

  // tiitle button & effect
  const appTitle = "PAY THE DRAGON!";

  //delays Title Button to resolve flashing font error, plus looks cool.
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Set a timer to change visibility after 1 second
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50); // 1/20 second delay

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {currentPage !== "home" && currentPage !== "onboarding" && (
        <div>
          <ActivityMonitor setCurrentPage={setCurrentPage} />
        </div>
      )}
      {!started ? (
        <div className="StartScreen">
          {!accessToken ? (
            <>
              <header className="App-preheader bebas-neue-regular">
                {appTitle}
              </header>
              <SigninResigsterModal
                setToken={setToken}
                setUserData={setUserData}
                setCurrentPage={setCurrentPage}
              />
            </>
          ) : (
            <>
              <button
                className="startButton"
                onClick={handleStart}
                disabled={loading}
                style={{
                  opacity: isVisible ? 1 : 0,
                  transition: "opacity 0.5s",
                }}
              >
                <header className="startButton-preheader ">{appTitle}</header>
              </button>
              <>
                {loading && (
                  <p
                    style={{
                      position: "absolute",
                      top: "70%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      margin: 0,
                    }}
                  >
                    Loading...
                  </p>
                )}
              </>
              <p
                style={{
                  visibility: displayError === "" ? "hidden" : "visible",
                  color: "rgb(154, 0, 0)",
                  minHeight: "5rem",
                }}
              >
                {displayError}
              </p>
              <button
                style={{
                  position: "absolute",
                  bottom: "3.5rem",
                  color: "#bdbdbd",
                }}
                onClick={() => {
                  handleSignOut();
                }}
              >
                click to logout
              </button>
            </>
          )}
        </div>
      ) : (
        <div className="main">
          <header
            className="App-header bebas-neue-regular"
            style={{ paddingTop: isUserOnIos ? "2.5rem" : "" }}
          >
            {appTitle}
          </header>
          <div className="App-body">
            {!showSavedPaymentList && currentPage !== "onboarding" && (
              <>
                <AddPayment
                  addPayment={addPayment}
                  tempPaymentList={tempPaymentList}
                  setShowPopup={setShowPopup}
                  setPopupType={setPopupType}
                  handleToggle={handleToggle} // Pass handleToggle here
                  handleUpdatePayment={handleUpdatePayment} // Pass handleUpdatePayment here
                  displayError={displayError} // Pass displayError here
                  setCurrentPage={setCurrentPage}
                />
              </>
            )}
            {showSavedPaymentList && (
              <>
                {currentPage === "home" && (
                  <>
                    <StatViewer
                      setShowPopup={setShowPopup}
                      setPopupType={setPopupType}
                    />
                    <br />
                    <br />
                    <br />
                    <br />
                    <>
                      <PaymentList
                        paymentList={savedPaymentList}
                        handleToggle={(id) => handleToggle(id, "saved")}
                      />
                      <DailyDebtPaid
                        savedPaymentList={savedPaymentList}
                        setCompletionPercent={setCompletionPercent}
                        displayError={displayError}
                        accessToken={accessToken}
                        setDisplayError={setDisplayError}
                        userId={userId}
                        setUserStats={setUserStats}
                      />
                      <Countdown
                        completionPercent={completionPercent}
                        setStarted={setStarted}
                        displayError={displayError}
                        setShowPopup={setShowPopup}
                        setPopupType={setPopupType}
                      />
                      <p
                        style={{
                          visibility:
                            displayError === "" ? "hidden" : "visible",
                          color: "rgb(154, 0, 0)",
                          minHeight: "5rem",
                        }}
                      >
                        {displayError}
                        <br></br>
                        <button
                          onClick={() => {
                            setStarted();
                            setDisplayError("");
                          }}
                        >
                          click to refresh
                        </button>
                      </p>

                      <DayTracker
                        savedPaymentList={savedPaymentList}
                        setSavedPaymentList={setSavedPaymentList}
                        setShowPopup={setShowPopup}
                        setPopupType={setPopupType}
                        isUserOnIos={isUserOnIos}
                      />
                    </>
                  </>
                )}
                {currentPage === "friends" && (
                  <FriendsPage
                    accessToken={accessToken}
                    setDisplayError={setDisplayError}
                    userData={userData}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup}
                    isUserOnIos={isUserOnIos}
                  />
                )}
                {currentPage === "account" && (
                  <AccountPage
                    accessToken={accessToken}
                    setDisplayError={setDisplayError}
                    displayError={displayError}
                    userData={userData}
                    setPopupType={setPopupType}
                    setShowPopup={setShowPopup}
                    isUserOnMobile={isUserOnMobile}
                  />
                )}

                {currentPage !== "onboarding" && (
                  <BottomNav
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    isUserOnIos={isUserOnIos}
                  />
                )}
              </>
            )}
            {!showSavedPaymentList && currentPage === "onboarding" && (
              <OnboardingPage setCurrentPage={setCurrentPage} />
            )}
            {showPopup && (
              <PopupModal
                popupType={popupType}
                onClose={() => {
                  setShowPopup(false);
                  setPopupType("");
                  setSelectedPaymentName("");
                }}
                onCompletePayment={handleCompletePayment}
                onSavePayments={handleSaveList}
                onUpdateWeekly={() => {
                  setSavedPaymentList({});
                }}
                onLogout={handleSignOut}
                onDeleteAccount={handleDeleteAccount}
                paymentName={selectedPaymentName}
                tempPaymentList={tempPaymentList}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
